import { render } from "./SavedStylesInspectorView.vue?vue&type=template&id=8fc81a3e"
import script from "./SavedStylesInspectorView.vue?vue&type=script&lang=js"
export * from "./SavedStylesInspectorView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sjoshi6/git/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__